import { render } from "./Niu.vue?vue&type=template&id=441e710f"
import script from "./Niu.vue?vue&type=script&lang=js"
export * from "./Niu.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__